import React from 'react';
import './loading.scss';
import { CircularProgress } from '@mui/material';

export function Loading({ fullscreen = true }: { fullscreen?: boolean }): JSX.Element {
  return (
    <div className='loading' data-fullscreen={fullscreen}>
      <CircularProgress />
    </div>
  );
}
